import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Home } from '@pages/Home';
import { StudentDetails } from '@pages/onboarding/StudentDetails';
import { SetupService } from '@pages/onboarding/SetupService';
import { PickupLocation } from '@pages/pickup/PickupLocation';
import { ReviewDetails } from '@pages/onboarding/ReviewDetails';
import { EditDetails } from '@pages/edit/EditDetails';
import { UserDetails } from '@pages/edit/UserDetails';
import { SelectPlans } from '@pages/plans/SelectPlans';
import { Processing } from '@pages/payment/Processing';
import { PaymentSuccess } from '@pages/payment/Success';
import { PaymentFailure } from '@pages/payment/Failure';
import { ViewSubscription } from '../pages/subscription/ViewSubscription';
import { FAQ } from '../pages/faq/FAQ';
import DriverLocationPage from '@pages/driver/index';
import { CampusSlugRedirect } from '@components/CampusSlugRedirect';
import { ROUTES } from '@utils/constants';
import { ProtectedRoute } from '@components/ProtectedRoute';

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public Routes - Accessible without authentication */}
      <Route 
        path="/driver" 
        element={<DriverLocationPage />} 
      />
      
      {/* Campus slug route — e.g. /allen, /dps, /vibgyor
          Extracts the slug, saves it, and redirects to home */}
      <Route
        path="/campus/:campusSlug"
        element={<CampusSlugRedirect />}
      />
      
      {/* Home/Login Route - Accessible to all, but redirects authenticated users to dashboard */}
      <Route 
        path={ROUTES.WELCOME} 
        element={
          <ProtectedRoute requireAuth={false}>
            <Home />
          </ProtectedRoute>
        } 
      />

      {/* Protected Routes - Requires authentication */}
      <Route 
        path={ROUTES.STUDENT_DETAILS} 
        element={
          <ProtectedRoute requireAuth={true}>
            <StudentDetails />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path={ROUTES.PICKUP_LOCATION} 
        element={
          <ProtectedRoute requireAuth={true}>
            <PickupLocation />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path={ROUTES.SETUP_SERVICE} 
        element={
          <ProtectedRoute requireAuth={true}>
            <SetupService />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path={ROUTES.REVIEW_DETAILS} 
        element={
          <ProtectedRoute requireAuth={true}>
            <ReviewDetails />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path={ROUTES.EDIT_DETAILS} 
        element={
          <ProtectedRoute requireAuth={true}>
            <EditDetails />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path={ROUTES.USER_DETAILS} 
        element={
          <ProtectedRoute requireAuth={true}>
            <UserDetails />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path={ROUTES.SELECT_PLANS} 
        element={
          <ProtectedRoute requireAuth={true}>
            <SelectPlans />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path={ROUTES.PAYMENT_PROCESSING}
        element={
          <ProtectedRoute requireAuth={true}>
            <Processing />
          </ProtectedRoute>
        } 
      />
      
      <Route
        path={ROUTES.PAYMENT_SUCCESS}
        element={
          <ProtectedRoute requireAuth={true}>
            <PaymentSuccess />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.PAYMENT_FAILURE}
        element={
          <ProtectedRoute requireAuth={true}>
            <PaymentFailure />
          </ProtectedRoute>
        }
      />

      {/* View Subscription — AD-566 item 3 */}
      <Route
        path={ROUTES.SUBSCRIPTION_DETAILS}
        element={
          <ProtectedRoute requireAuth={true}>
            <ViewSubscription />
          </ProtectedRoute>
        }
      />

      {/* FAQ */}
      <Route
        path={ROUTES.FAQ}
        element={
          <ProtectedRoute requireAuth={true}>
            <FAQ />
          </ProtectedRoute>
        }
      />

      {/* Catch-all - Check if it's a campus slug, otherwise redirect to home */}
      <Route path="/:campusSlug" element={<CampusSlugRedirect />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
};